module.exports = __webpack_public_path__ + "img/Black-Box-img-cn.39ec579a.png";